import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { DocumentTitle } from './DocumentTitle';
import { ElectionOpenSpan } from '../_generatedTypes.g';
import { api, ReadAs } from '../api';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getTranslator } from '../Translator';
import { panicStateSet } from '../features/innerState/innerStateSlice';
import { useAppSelector } from '../hooks';

export const ElectionHistory = () => {
    const token = useAppSelector(state => state.clientState.RequestVerificationToken);
    const language = useAppSelector(state => state.language);
    const dispatch = useDispatch();
    const t = getTranslator(language);

    const [historyLines, setHistoryLines] = useState<Array<ElectionOpenSpan>>(new Array<ElectionOpenSpan>());
    const [doneLoading, setDoneLoading] = useState<boolean>(false);

    useEffect(() => {
        fetchHistory();
    }, []); //door loze param (de array) wordt useeffect eenmalig uitgevoerd

    const fetchHistory = async () => {
        return await api(token).Elections.History<void>()
            .ok(historyLines => { setHistoryLines(historyLines); setDoneLoading(true) }, ReadAs.Json)
            .fail(() => dispatch(panicStateSet()));
    }

    return <div className="admin__usageHistory">
        <DocumentTitle title={t['Usage history']} />
        <h1>{t['Usage history']}</h1>
        {(() => {
            if (!doneLoading) {
                return t['Loading...'];
            } else if (!historyLines.length) {
                return t['No results found'];
            }
            return <table>
                <thead>
                    <tr>
                        <th>{t['Election']}</th>
                        <th>{t['Open']}</th>
                        <th>{t['Closed']}</th>
                        <th>{t['All Voters']}</th>
                    </tr>
                </thead>
                <tbody>
                    {historyLines.map(line => <tr key={line.ElectionId}>
                        <td>{t.translate(line.Name)}</td>
                        <td>{moment(line.Span.From).format('lll')} <i className="admin__usageHistory__fromNow">{moment(line.Span.From).fromNow()}</i></td>
                        <td>{moment(line.Span.Until).format('lll')} <i className="admin__usageHistory__fromNow">{moment(line.Span.Until).fromNow()}</i></td>
                        <td>{line.TotalVotingRights}</td>
                    </tr>)}
                </tbody>
            </table>
        })()}
        <p className="buttonrow">
            <Link className="linkbutton" to={'/admin'}>{t['Back']}</Link>
        </p>
    </div>
}
